import { createGetPropGetter } from '@/store/utils';

export default {
  requests: createGetPropGetter('requests', []),
  requestListOptions: createGetPropGetter('requestListOptions', {}),
  requestListSort(state, { requestListOptions = {} }) {
    return requestListOptions.sort || {};
  },
};
